import { createContext } from 'react'

export const initialType = ''

export const NotiTypeContext = createContext(initialType)
